import { type MerchantsTypes, merchantsApi } from "../client";

export const getOrder = async (
  onlineOrderId?: string,
): Promise<
  MerchantsTypes.components["schemas"]["GetExternalOrderInfoWithPromocodesResp"]
> => {
  if (!onlineOrderId) {
    throw new Error("onlineOrderId is missing");
  }

  const { data } = await merchantsApi.GET(
    "/api/merchants-service/public/order/{online_order_id}",
    { params: { path: { online_order_id: onlineOrderId } } },
  );

  if (!data?.data) {
    throw new Error("Error getting order data");
  }

  return data.data;
};
